import { IDisposable } from "Global/Base/IDisposable";
import { UUID } from "Global/Base/IDs/UUID";
import { loadOriginalRightsDefinition } from "UI/UI/Rights/OriginalRightsDefinitionLoader";
import { Control } from "../Controls/Control";
import { ControlParams, IHTMLElementWithControl } from "../Controls/ControlInterfaces";
import { UIManager } from "../UIManager";
import { XGButton } from "./Actions/XGButton";
import { AlignPanel } from "./AlignPanel";
import { WidgetForm } from "./WidgetForm";

export class WidgetPanel extends Control {
    private _form: WidgetForm;

    constructor(params: ControlParams) {
        super(params);
    }

    /**
     * Inicializuje WidgetPanel
     */
    public async init(): Promise<void> {
        const formName = this.element.getAttribute("data-name");
        const formInstanceId = formName ? `${formName}-${UUID.generate()}` : UUID.generate();
        this._form = new WidgetForm({
            ownerForm: null,
            element: this.element,
            originalRightsDefinition: this.originalRightsDefinition,
            formInstanceId,
        });
        await this._form.init();

        this.element.classList.add("widget-panel");

        const wrappingDiv = this.element.querySelector("div");
        const originalRightsDefinition = loadOriginalRightsDefinition(wrappingDiv);
        new AlignPanel({ element: wrappingDiv, originalRightsDefinition });

        if (!this.element.id) {
            this.element.id = UIManager.instance.generateElementID();
        }

        const fits = this._form.element.querySelector("[data-tsccontrol=\"AlignPanel\"]");
        if (fits) {
            fits.classList.add("fits", "counted");
        }

        this._prepareButtons();
    }

    protected _prepareButtons(): void {
        const buttonElements = Array.from(this.element.querySelectorAll("[data-behaviour='button']")) as IHTMLElementWithControl[];
        for (const buttonElement of buttonElements) {
            const el = buttonElement.tscControl as XGButton;
            if (el) {
                el.xgAction.ownerForm = this._form;
            }
        }
    }

    public override dispose(): void {
        const frames = Array.from(this.element.querySelectorAll("[data-behaviour='frame']")) as IHTMLElementWithControl[];
        for (const frameElement of frames) {
            const frame = frameElement.tscControl;
            if (frame instanceof IDisposable)
                frame.dispose();

            frameElement.tscControl = null;
        }
        super.dispose();
    }
}
